import React from 'react';
import styled, { css } from 'styled-components';

import { Device, StepName } from '../../types';
import Preview from '../Preview';
import type { Biedwijzer_AppConfig, InitialState } from '../../types';

type StepPreview_Type = {
  device: Device;
  step: StepName;
  height?: number;
  width?: number;
};

type Preview_Type = StepPreview_Type;

export type Props = {
  previews?: Array<Preview_Type>;
  data: {
    appConfigData?: Partial<Biedwijzer_AppConfig>;
    initialState?: Partial<InitialState>;
  } | null;
};

const PreviewContainer: React.FCC<Props> = ({
  dataTestId,
  previews = [{ step: StepName.AddressSearch, device: 'desktop' }],
  data,
  ...rest
}) => {
  const previewComponents = previews.map((preview, index) => {
    const { step, device, height, width } = preview;
    return (
      <Preview
        key={index}
        height={height ?? 300}
        width={width ?? 350}
        device={device}
        step={step}
        data={data}
      />
    );
  });

  return (
    <Container data-testid={dataTestId} {...rest}>
      {previewComponents}
    </Container>
  );
};

const Container = styled.div<{}>(
  ({ theme }) => css`
    display: flex;
    justify-content: space-around;
    background-color: ${theme.color('white', 'dark')};
    overflow: hidden;
    border-bottom: ${theme.getTokens().border.width.base} solid
      ${theme.color('tertiary', 'light')};
  `,
);

export default PreviewContainer;
